<div class="container">
	<div class="sidenav">
		<nav class="sidebar" id="sidebar">
			<ul>
				<li>
					<button mat-button [routerLink]="['/']" routerLinkActive="active" (click)="toggleSidebar()"
						[routerLinkActiveOptions]="{exact: true}" class="sidebar-image-button">
						<mat-icon>home</mat-icon>
						<span class="sidebar-text">HOME</span>
					</button>
				</li>
				<h5>CIFRIS 26 - ROME</h5>
				<li>
					<button mat-button [routerLink]="['/cifris26']" routerLinkActive="active" (click)="toggleSidebar()"
						[routerLinkActiveOptions]="{exact: true}" class="sidebar-image-button">
						<mat-icon>stadium</mat-icon>
						<span class="sidebar-text">CIFRIS26</span>
					</button>
				</li>
				<li>
					<button mat-button [routerLink]="['/cifris26/registration']" routerLinkActive="active"
						(click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
						class="sidebar-image-button">
						<mat-icon>event_seat</mat-icon>
						<span class="sidebar-text">Registration</span>
					</button>
				</li>
				<li>
					<button mat-button [routerLink]="['/cifris26/program']" routerLinkActive="active"
						(click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
						class="sidebar-image-button">
						<mat-icon>date_range</mat-icon>
						<span class="sidebar-text">Program</span>
					</button>
				</li>
				<li>
					<button mat-button [routerLink]="['/cifris26/workshops']" routerLinkActive="active"
						(click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
						class="sidebar-image-button">
						<mat-icon>architecture</mat-icon>
						<span class="sidebar-text">Workshops</span>
					</button>
				</li>
				<li>
					<button mat-button [routerLink]="['/cifris26/venue']" routerLinkActive="active"
						(click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
						class="sidebar-image-button">
						<mat-icon>location_on</mat-icon>
						<span class="sidebar-text">Venue</span>
					</button>
				</li>
				
				<li>
					<button mat-button [routerLink]="['/cifris26/proceedings']" routerLinkActive="active"
						(click)="toggleSidebar()" [routerLinkActiveOptions]="{exact: true}"
						class="sidebar-image-button">
						<mat-icon>menu_book</mat-icon>
						<span class="sidebar-text">Proceedings</span>
					</button>
				</li>
			</ul>
		</nav>
	</div>
	<div class="content" (click)="toggleSidebar(true)">

<div style="display: flex; justify-content: center; align-items: flex-start; margin-bottom: 10px;">
  <!-- Immagine ACN a sinistra con margin-top negativo -->

  <!-- Testo centrale -->
  <div style="text-align: center;">
    <p style="color: var(--cifris_blue); font-size: larger; font-weight: bold; margin: 0; display: inline;">
      CIFRIS26 –
      <i style="font-weight: normal;">an event by De Cifris & Roma Tre University</i>
    </p>
    <p style="margin: 0; font-size: smaller;">
      Venue: Roma Tre University<br>
	  <b> October 5th, 2026</b>
    </p>
    <hr style="width: 60%; margin-left: auto; margin-right: auto; color: var(--cifris_blue);">
  </div>


</div>

		
		<router-outlet></router-outlet>
	</div>
	<ul class="bottomnav-menu">
		<li>
			<button mat-button [routerLink]="['/']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
				<mat-icon style="color:var(--cifris_azure_transparent)">home</mat-icon>
				<span style="color:var(--cifris_azure_transparent);">HOME</span>
			</button>
		</li>
		<li>
			<button mat-button [routerLink]="['/cifris26']" routerLinkActive="active"
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon style="color:var(--cifris_azure_transparent)">stadium</mat-icon>
				<span style="color:var(--cifris_azure_transparent)">CIFRIS26</span>
			</button>
		</li>
		<li>
			<button mat-button [routerLink]="['/cifris26/registration']" routerLinkActive="active"
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon>event_seat</mat-icon>
				<span>Registration</span>
			</button>
		</li>
		<li>
			<button mat-button [routerLink]="['/cifris26/program']" routerLinkActive="active"
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon>date_range</mat-icon>
				<span>Program</span>
			</button>
		</li>
		<li>
			<button mat-button [routerLink]="['/cifris26/workshops']" routerLinkActive="active"
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon>architecture</mat-icon>
				<span>Workshops</span>
			</button>
		</li>
		<li>
			<button mat-button [routerLink]="['/cifris26/venue']" routerLinkActive="active"
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon>location_on</mat-icon>
				<span>Venue & shuttles</span>
			</button>
		</li>
		<li>
			<button mat-button [routerLink]="['/cifris26/proceedings']" routerLinkActive="active"
				[routerLinkActiveOptions]="{exact: true}">
				<mat-icon>menu_book</mat-icon>
				<span>Proceedings</span>
			</button>
		</li>
	</ul>
</div>
